<div class="user-card-container">
  <div class="image-wrapper">
    <img class="user-card-image" [src]="profilePicture" [alt]="data.nev" (error)="updateErrorUrl()" />
  </div>
  <div class="user-card-data">
    <span class="name" (click)="onClick()">{{ data.nev }}</span>
    <span class="address">{{ data.telepules }}</span>
    <span class="clickable-data" (click)="navigate('mailto:' + data.email)">{{ data.email }}</span>
    <span class="clickable-data" (click)="navigate('tel:' + data.telefonszam)">{{ data.telefonszam }}</span>
  </div>
</div>
